import React, { Component } from "react";

class Endorsement extends Component {
  render() {
    const { hoData } = this.props;

    return (
      <div>
        {hoData && hoData.trayType && (
          <div className="endorsement">
            <p>{hoData.trayType}</p>{" "}
          </div>
        )}
      </div>
    );
  }
}

export default Endorsement;
